var map = {
	"./en-AU.json": 41335,
	"./en-NZ.json": 3444,
	"./en.json": 75121,
	"./nl.json": 19110,
	"./si.json": 25416
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69086;
module.exports = webpackAsyncContext;